import { CalendarBlank, CaretDown } from '@phosphor-icons/react';
import { DropdownMenu } from 'src/components/DropdownMenu';
import { SelectBox } from 'src/components/SelectBox';

interface ChartContainerProps {
  title: string;
  titleOptions: string[];
  selectedTitle: number;
  onTitleChange: (title: string) => void;
  isTitleDropdownOpen: boolean;
  onTitleDropdownToggle: () => void;
  timePeriodOptions: Array<{ value: string; label: string }>;
  selectedTimePeriod: string;
  onTimePeriodChange: (value: string) => void;
  actionOptions: Array<{ value: string; label: string }>;
  selectedAction: string;
  onActionChange: (value: string) => void;
  children: React.ReactNode;
  className?: string;
}

export const ChartContainer = ({
  titleOptions,
  selectedTitle,
  onTitleChange,
  isTitleDropdownOpen,
  onTitleDropdownToggle,
  timePeriodOptions,
  selectedTimePeriod,
  onTimePeriodChange,
  actionOptions,
  selectedAction,
  onActionChange,
  children,
  className = '',
}: ChartContainerProps) => {
  return (
    <div className={className}>
      <div className="flex items-center justify-between px-6 py-4">
        <div className="relative">
          <div
            className="flex items-center gap-2 cursor-pointer hover:bg-neutral-50 px-2 py-1 rounded"
            onClick={onTitleDropdownToggle}
          >
            <h3 className="text-lg font-medium">
              {titleOptions[selectedTitle]}
            </h3>
            <CaretDown size={16} className="text-neutral-500" />
          </div>

          <DropdownMenu
            isOpen={isTitleDropdownOpen}
            position="bottom-left"
            onItemClick={onTitleChange}
            className="min-w-[300px]"
            items={titleOptions}
          />
        </div>

        <div className="flex items-center gap-2">
          <SelectBox
            options={timePeriodOptions}
            value={
              timePeriodOptions.find(
                (option) => option.value === selectedTimePeriod,
              ) || null
            }
            onChange={onTimePeriodChange}
            variant="outlined"
            size="small"
            className="min-w-[120px]"
            icon={<CalendarBlank size={16} />}
          />
          <SelectBox
            options={actionOptions}
            value={
              actionOptions.find((option) => option.value === selectedAction) ||
              null
            }
            onChange={onActionChange}
            variant="outlined"
            size="small"
            className="min-w-[120px]"
          />
        </div>
      </div>

      <div className="w-full border-t border-neutral-100"></div>

      <div className="px-6 py-4">{children}</div>
    </div>
  );
};
